module.exports = __webpack_public_path__ + "img/records.4d39f2dc.svg";